export default __webpack_public_path__ + "0d4b53e8f3b18e4aafce7a28d8f0d35a.jpg";